<template>
  <!-- 带有模板下载以及文件上传的modal -->
  <div class="batch-upload-Cancel">
    <a-button
      type="primary"
      :icon="icon"
      class="add-btn"
      @click="showModal = true"
    >
      {{ btnText }}
    </a-button>
    <a-modal
      :title="modalTitle"
      :visible="showModal"
      :mask-closable="false"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <p>
        <span>请下载模板：</span>
        <a herf="javascript:;" @click="download">下载模板</a>
      </p>
      <p>
        <span>请上传文件：</span>
        <a-upload
          :beforeUpload="handleBeforeUpload"
          :fileList="fileList"
          :remove="handleBatchFileRemove"
          @change="handleBatchFileChange"
        >
          <a-button>
            <a-icon type="upload" />
            选取文件
          </a-button>
        </a-upload>
      </p>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'BatchUploadCancel',
  data() {
    return {
      showModal: false,
      fileList: [],
    }
  },
  props: {
    btnText: {
      type: String,
      default: '批量上传',
    },
    icon: {
      type: String,
      default: 'cloud-upload',
    },
    modalTitle: {
      type: String,
      default: '批量上传',
    },
  },
  methods: {
    handleOk() {
      this.$emit('ok', this.fileList)
    },
    handleCancel() {
      this.showModal = false
      this.fileList = []
    },
    download() {
      this.$emit('download')
    },
    handleBeforeUpload(file) {
      this.fileList = [...this.fileList, file]
      return false
    },
    handleBatchFileRemove() {
      this.fileList = []
    },
    handleBatchFileChange() {
      if (this.fileList.length > 1) {
        this.fileList.shift()
      }
    },
  },
}
</script>

<style lang="less" scoped>
.batch-upload-Cancel {
  margin-right: 20px;
  display: inline-block;
}
</style>
